module.exports = __webpack_public_path__ + "static/img/pico31.5bbeb4f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pico31.png
// module id = /e5U
// module chunks = 0